import React, { useEffect, useState, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { sortBy } from 'lodash';

import AppContext from '../contexts/app-context';
import OrganizationsFromPortfolios from '../helpers/OrganizationsFromPortfolios';

function OrganizationSelect({ setOrganizations, isLoading }) {
  const {
    setActiveOrganization,
    userSelectedOrganization,
    userOrganizations,
    userSelectedPortfolio,
  } = useContext(AppContext);

  const [localOrgs, setLocalOrgs] = useState([]);

  // change available orgs on portfolio changes
  useEffect(() => {
    const new_orgs = OrganizationsFromPortfolios(
      userOrganizations,
      userSelectedPortfolio.id
    );
    setOrganizations(new_orgs);
    setLocalOrgs(sortBy(new_orgs, ['name']));
  }, [userOrganizations, userSelectedPortfolio.id, setOrganizations]);

  const isOrgInPortfolio = (orgId, organizations) =>
    organizations.some((org) => org.id === orgId);

  //change selected org on local orgs changes
  useEffect(() => {
    if (localOrgs.length) {
      let organization = {};
      !userSelectedOrganization.id ||
      !isOrgInPortfolio(userSelectedOrganization.id, localOrgs)
        ? (organization = {
            id: parseInt(localOrgs[0]['id']),
            name: localOrgs[0]['name'],
          })
        : (organization = {
            id: parseInt(userSelectedOrganization.id),
            name: userSelectedOrganization.name,
          });
      setActiveOrganization(organization);
    }
  }, [
    userSelectedOrganization.id,
    userSelectedOrganization.name,
    setActiveOrganization,
    localOrgs,
  ]);

  return (
    <Form inline style={{ marginBottom: '0.5em' }}>
      <Form.Label
        style={{
          display: 'block',
          marginRight: '.5rem',
        }}
      >
        Organization:
      </Form.Label>
      <Form.Control
        style={{ float: 'right' }}
        as='select'
        size='sm'
        onChange={(e) => {
          setActiveOrganization({
            id: parseInt(e.target.value),
            name: localOrgs.find((org) => org.id === parseInt(e.target.value))
              .name,
          });
        }}
        value={
          userSelectedOrganization.id !== null
            ? userSelectedOrganization.id
            : ''
        }
        disabled={isLoading}
        data-id='page-head_org'
      >
        {localOrgs.map((org) => (
          <option key={`org-opt-${org.id}`} value={org.id}>
            {org.name}
          </option>
        ))}
      </Form.Control>
    </Form>
  );
}

export default OrganizationSelect;
